// extracted by mini-css-extract-plugin
export var divider = "_m5-0";
export var labelWrapper = "_m5-2";
export var lineSvg = "_m5-1";